// import React, { useState } from 'react';
// import { Table, Spinner, Form, Row, Col, Button, Alert, Badge, CardFooter, CardTitle } from 'react-bootstrap';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { Card, CardBody, CardHeader } from '@components/card/card';
// import { ntxAPI } from '@API/axiosNeatex';
// import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';
// import type { APIResponse } from '@store/Shared/shared';
// import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';

// import Loading from '@components/Shared/Loader/Loading';

// interface WarehouseTransfer {
//   transferDate: string;
//   transferCode: string;
//   itemId: string;
//   itemCode: string;
//   itemName: string;
//   itemName2: string;
//   fromInventoryId: string;
//   fromInventoryName: string | null;
//   toInventoryId: string;
//   toInventoryName: string | null;
//   quantity: number;
//   unitPrice: number;
// }

// const WarehouseTransferReport: React.FC = () => {
//   const [data, setData] = useState<WarehouseTransfer[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);

//   const { ItemsOptions, loading: loading1, error: error1 } = useGetItemsList();
//   const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();
//   const { t, i18n } = useTranslation();

//   const [itemId, setItemId] = useState<string | null>('');

//   const [fromInventoryId, setFromInventoryId] = useState<string | null>('');
//   const [toInventoryId, setToInventoryId] = useState<string | null>('');

//   const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
//   const [startDate, endDate] = dateRange;

//   const fetchData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const { data } = await ntxAPI.get<APIResponse<WarehouseTransfer[]>>(`InventoryReports/warehouse-transfer`, {
//         params: {
//           ItemId: itemId,
//           FromInventoryId: fromInventoryId,
//           ToInventoryId: toInventoryId,
//           StartDate: startDate,
//           EndDate: endDate
//         }
//       });

//       if (data.succeeded === true) {
//         setData(data.data);
//       } else {
//         setError(data instanceof Error ? data.message : t('UnknownError'));
//       }
//     } catch (err) {
//       setError(err instanceof Error ? err.message : t('UnknownError'));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetFilters = () => {
//     setItemId(null);
//     setFromInventoryId(null);
//     setToInventoryId(null);
//     setDateRange([null, null]);
//   };

//   const formatCurrency = (amount: number): string => {
//     if (amount === 0) return '-';
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD'
//     }).format(amount);
//   };

//   const formatDate = (dateString: string): string => {
//     return new Date(dateString).toLocaleDateString();
//   };

//   const formatQuantity = (quantity: number): string => {
//     return new Intl.NumberFormat('en-US').format(quantity);
//   };

//   // Calculate transfer statistics
//   const calculateTransferStats = () => {
//     const totalTransfers = data.length;
//     const totalQuantity = data.reduce((sum, item) => sum + item.quantity, 0);
//     const uniqueItems = new Set(data.map(item => item.itemId)).size;
//     const uniqueInventories = new Set([
//       ...data.map(item => item.fromInventoryId),
//       ...data.map(item => item.toInventoryId)
//     ]).size;

//     return { totalTransfers, totalQuantity, uniqueItems, uniqueInventories };
//   };

//   const { totalTransfers, totalQuantity, uniqueItems, uniqueInventories } = calculateTransferStats();

//   return (
//     <div className='container mt-4'>
//       <Card>
//         <CardHeader className='d-flex justify-content-between align-items-center'>
//           <h5 className='mb-0'>Warehouse Transfer Report</h5>
//           {data.length > 0 && (
//             <div>
//               <span className='me-2'>Showing: {data.length} transfers</span>
//             </div>
//           )}
//         </CardHeader>

//         <CardBody>
//           {error && (
//             <Alert variant='danger' className='mb-4'>
//               {t('ErrorLoadingData')}: {error}
//             </Alert>
//           )}

//           <Card className='mb-4'>
//             <CardHeader>{t('Filters')}</CardHeader>
//             <Loading loading={loading1 || loading2} error={error1 || error2}>
//               <CardBody>
//                 <Form>
//                   <Row className='g-3'>
//                     <Col md={3}>
//                       <Form.Group>
//                         <Form.Label>{t('itemName')}</Form.Label>
//                         <Select
//                           classNamePrefix='react-select'
//                           isSearchable
//                           isClearable
//                           options={ItemsOptions}
//                           onChange={(option: any) => setItemId(option?.value || null)}
//                           value={ItemsOptions.find(f => f.value === itemId)}
//                           placeholder={t('Choose')}
//                           menuPortalTarget={document.body}
//                           styles={{
//                             menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                           }}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={3}>
//                       <Form.Group>
//                         <Form.Label>{t('FromInventory')}</Form.Label>
//                         <Select
//                           classNamePrefix='react-select'
//                           isSearchable={true}
//                           isClearable
//                           options={InventoryOptions}
//                           onChange={(option: any) => {
//                             setFromInventoryId(option === null ? null : option.value);
//                           }}
//                           placeholder={t('Choose')}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={3}>
//                       <Form.Group>
//                         <Form.Label>{t('ToInventory')}</Form.Label>
//                         <Select
//                           classNamePrefix='react-select'
//                           isSearchable={true}
//                           isClearable
//                           options={InventoryOptions}
//                           onChange={(option: any) => {
//                             setToInventoryId(option === null ? null : option.value);
//                           }}
//                           placeholder={t('Choose')}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col md={3}>
//                       <Form.Group>
//                         <Form.Label>{t('DateRange')}</Form.Label>
//                         <DatePicker
//                           selectsRange={true}
//                           startDate={startDate}
//                           endDate={endDate}
//                           onChange={update => setDateRange(update)}
//                           isClearable={true}
//                           className='form-control text-center'
//                           placeholderText={t('SelectDateRange')}
//                         />
//                       </Form.Group>
//                     </Col>

//                     <Col xs={12} className='text-end'>
//                       <Button variant='secondary' onClick={resetFilters} className='me-2'>
//                         {t('ResetFilters')}
//                       </Button>
//                       <Button variant='primary' onClick={fetchData} disabled={loading}>
//                         {loading ? (
//                           <>
//                             <Spinner
//                               as='span'
//                               animation='border'
//                               size='sm'
//                               role='status'
//                               aria-hidden='true'
//                               className='me-2'
//                             />
//                             {t('Loading')}
//                           </>
//                         ) : (
//                           t('LoadReport')
//                         )}
//                       </Button>
//                     </Col>
//                   </Row>
//                 </Form>
//               </CardBody>
//             </Loading>
//           </Card>

//           {/* Transfer Summary */}
//           {data.length > 0 && (
//             <Row className='mb-4'>
//               <Col md={3}>
//                 <Card className='text-center'>
//                   <CardBody>
//                     <CardTitle>Total Transfers</CardTitle>
//                     <h3 className='text-primary'>{totalTransfers}</h3>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={3}>
//                 <Card className='text-center'>
//                   <CardBody>
//                     <CardTitle>Total Quantity</CardTitle>
//                     <h3 className='text-success'>{formatQuantity(totalQuantity)}</h3>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={3}>
//                 <Card className='text-center'>
//                   <CardBody>
//                     <CardTitle>Unique Items</CardTitle>
//                     <h3 className='text-info'>{uniqueItems}</h3>
//                   </CardBody>
//                 </Card>
//               </Col>
//               <Col md={3}>
//                 <Card className='text-center'>
//                   <CardBody>
//                     <CardTitle>Warehouses</CardTitle>
//                     <h3 className='text-warning'>{uniqueInventories}</h3>
//                   </CardBody>
//                 </Card>
//               </Col>
//             </Row>
//           )}

//           {/* Results Section */}
//           {loading ? (
//             <div className='text-center my-5'>
//               <Spinner animation='border' role='status'>
//                 <span className='visually-hidden'>Loading...</span>
//               </Spinner>
//               <p className='mt-2'>Loading warehouse transfer data...</p>
//             </div>
//           ) : data.length > 0 ? (
//             <div className='table-responsive'>
//               <Table striped bordered hover>
//                 <thead>
//                   <tr>
//                     <th>Transfer Date</th>
//                     <th>Transfer Code</th>
//                     <th>Item</th>
//                     <th>Item Code</th>
//                     <th>From Inventory</th>
//                     <th>To Inventory</th>
//                     <th>Quantity</th>
//                     <th>Unit Price</th>
//                     <th>Transfer Value</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.map((transfer, index) => (
//                     <tr key={`${transfer.transferCode}-${index}`}>
//                       <td>{formatDate(transfer.transferDate)}</td>
//                       <td>
//                         <Badge bg='primary'>{transfer.transferCode}</Badge>
//                       </td>
//                       <td>
//                         <div>{transfer.itemName}</div>
//                         {transfer.itemName2 && <div className='text-muted small'>{transfer.itemName2}</div>}
//                       </td>
//                       <td>{transfer.itemCode}</td>
//                       <td className='text-danger'>{transfer.fromInventoryName || 'Unknown Inventory'}</td>
//                       <td className='text-success'>{transfer.toInventoryName || 'Unknown Inventory'}</td>
//                       <td className='fw-bold'>{formatQuantity(transfer.quantity)}</td>
//                       <td>{formatCurrency(transfer.unitPrice)}</td>
//                       <td className='fw-bold text-info'>{formatCurrency(transfer.quantity * transfer.unitPrice)}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           ) : (
//             <div className='text-center py-5'>
//               <p>No data available. Set your filters and click "Load Report" to generate.</p>
//             </div>
//           )}
//         </CardBody>

//         {data.length > 0 && (
//           <CardFooter className='text-muted'>
//             <div className='row'>
//               <div className='col-md-6'>
//                 <small>
//                   <strong>Transfer Summary:</strong> {totalTransfers} transfers involving {uniqueItems} items across{' '}
//                   {uniqueInventories} warehouses
//                 </small>
//               </div>
//               <div className='col-md-6 text-end'>
//                 <small>Report generated on {new Date().toLocaleString()}</small>
//               </div>
//             </div>
//           </CardFooter>
//         )}
//       </Card>
//     </div>
//   );
// };

// export default WarehouseTransferReport;

import React, { useState } from 'react';
import { Table, Spinner, Form, Row, Col, Button, Alert, Badge, CardFooter, CardTitle } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Card, CardBody, CardHeader } from '@components/card/card';
import { ntxAPI } from '@API/axiosNeatex';
import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import type { APIResponse } from '@store/Shared/shared';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import Loading from '@components/Shared/Loader/Loading';

interface WarehouseTransfer {
  transferDate: string;
  transferCode: string;
  itemId: string;
  itemCode: string;
  itemName: string;
  itemName2: string;
  fromInventoryId: string;
  fromInventoryName: string | null;
  toInventoryId: string;
  toInventoryName: string | null;
  quantity: number;
  unitPrice: number;
}

const WarehouseTransferReport: React.FC = () => {
  const [data, setData] = useState<WarehouseTransfer[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { ItemsOptions, loading: loading1, error: error1 } = useGetItemsList();
  const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();
  const { t, i18n } = useTranslation();

  const [itemId, setItemId] = useState<string | null>(null);
  const [fromInventoryId, setFromInventoryId] = useState<string | null>(null);
  const [toInventoryId, setToInventoryId] = useState<string | null>('');
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
  const [startDate, endDate] = dateRange;

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await ntxAPI.get<APIResponse<WarehouseTransfer[]>>(`InventoryReports/warehouse-transfer`, {
        params: {
          ItemId: itemId,
          FromInventoryId: fromInventoryId,
          ToInventoryId: toInventoryId,
          StartDate: startDate,
          EndDate: endDate
        }
      });

      if (data.succeeded === true) {
        setData(data.data);
      } else {
        setError(data instanceof Error ? data.message : t('UnknownError'));
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : t('UnknownError'));
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setItemId(null);
    setFromInventoryId(null);
    setToInventoryId(null);
    setDateRange([null, null]);
  };

  const formatQuantity = (quantity: number): string => {
    return new Intl.NumberFormat('en-US').format(quantity);
  };

  // Calculate transfer statistics
  const calculateTransferStats = () => {
    const totalTransfers = data.length;
    const totalQuantity = data.reduce((sum, item) => sum + item.quantity, 0);
    const uniqueItems = new Set(data.map(item => item.itemId)).size;
    const uniqueInventories = new Set([
      ...data.map(item => item.fromInventoryId),
      ...data.map(item => item.toInventoryId)
    ]).size;

    return { totalTransfers, totalQuantity, uniqueItems, uniqueInventories };
  };

  const { totalTransfers, totalQuantity, uniqueItems, uniqueInventories } = calculateTransferStats();

  return (
    <div className='container mt-4'>
      <Card>
        <CardHeader className='d-flex justify-content-between align-items-center'>
          <h5 className='mb-0'>{i18n.language === 'en' ? 'Warehouse Transfer Report' : 'تقرير تحويلات المخازن'}</h5>
          {data.length > 0 && (
            <div>
              <span className='me-2'>
                {i18n.language === 'en' ? `Showing: ${data.length} transfers` : `عرض: ${data.length} تحويل`}
              </span>
            </div>
          )}
        </CardHeader>

        <CardBody>
          {error && (
            <Alert variant='danger' className='mb-4'>
              {i18n.language === 'en' ? 'Error loading data:' : 'خطأ في تحميل البيانات:'} {error}
            </Alert>
          )}

          <Card className='mb-4'>
            <CardHeader>{i18n.language === 'en' ? 'Filters' : 'الفلاتر'}</CardHeader>
            <Loading loading={loading1 || loading2} error={error1 || error2}>
              <CardBody>
                <Form>
                  <Row className='g-3'>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>{t('itemName')}</Form.Label>
                        <Select
                          classNamePrefix='react-select'
                          isSearchable
                          isClearable
                          options={ItemsOptions}
                          onChange={(option: any) => setItemId(option?.value || null)}
                          value={ItemsOptions.find(f => f.value === itemId)}
                          placeholder={t('Choose')}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                          }}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>{i18n.language === 'en' ? 'From Inventory' : 'من المخزن'}</Form.Label>
                        <Select
                          classNamePrefix='react-select'
                          isSearchable={true}
                          isClearable
                          options={InventoryOptions}
                          onChange={(option: any) => {
                            setFromInventoryId(option === null ? null : option.value);
                          }}
                          placeholder={t('Choose')}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>{i18n.language === 'en' ? 'To Inventory' : 'إلى المخزن'}</Form.Label>
                        <Select
                          classNamePrefix='react-select'
                          isSearchable={true}
                          isClearable
                          options={InventoryOptions}
                          onChange={(option: any) => {
                            setToInventoryId(option === null ? null : option.value);
                          }}
                          placeholder={t('Choose')}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>{i18n.language === 'en' ? 'Date Range' : 'نطاق التاريخ'}</Form.Label>
                        <DatePicker
                          selectsRange={true}
                          startDate={startDate}
                          endDate={endDate}
                          onChange={update => setDateRange(update)}
                          isClearable={true}
                          className='form-control text-center'
                          placeholderText={i18n.language === 'en' ? 'Select date range' : 'اختر نطاق التاريخ'}
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} className={`text-end  `}>
                      <Button variant='secondary' onClick={resetFilters} className='me-2'>
                        {i18n.language === 'en' ? 'Reset Filters' : 'إعادة تعيين الفلاتر'}
                      </Button>
                      <Button variant='primary' onClick={fetchData} disabled={loading}>
                        {loading ? (
                          <>
                            <Spinner
                              as='span'
                              animation='border'
                              size='sm'
                              role='status'
                              aria-hidden='true'
                              className='me-2'
                            />
                            {i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}
                          </>
                        ) : i18n.language === 'en' ? (
                          'Load Report'
                        ) : (
                          'تحميل التقرير'
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Loading>
          </Card>

          {/* Transfer Summary */}
          {data.length > 0 && (
            <Row className='mb-4'>
              <Col md={3}>
                <Card className='text-center'>
                  <CardBody>
                    <CardTitle>{i18n.language === 'en' ? 'Total Transfers' : 'إجمالي التحويلات'}</CardTitle>
                    <h3 className='text-primary'>{totalTransfers}</h3>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card className='text-center'>
                  <CardBody>
                    <CardTitle>{i18n.language === 'en' ? 'Total Quantity' : 'إجمالي الكمية'}</CardTitle>
                    <h3 className='text-success'>{formatQuantity(totalQuantity)}</h3>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card className='text-center'>
                  <CardBody>
                    <CardTitle>{i18n.language === 'en' ? 'Unique Items' : 'أصناف فريدة'}</CardTitle>
                    <h3 className='text-info'>{uniqueItems}</h3>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card className='text-center'>
                  <CardBody>
                    <CardTitle>{i18n.language === 'en' ? 'Warehouses' : 'المخازن'}</CardTitle>
                    <h3 className='text-warning'>{uniqueInventories}</h3>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {/* Results Section */}
          {loading ? (
            <div className='text-center my-5'>
              <Spinner animation='border' role='status'>
                <span className='visually-hidden'>{i18n.language === 'en' ? 'Loading...' : 'جاري التحميل...'}</span>
              </Spinner>
              <p className='mt-2'>
                {i18n.language === 'en' ? 'Loading warehouse transfer data...' : 'جاري تحميل بيانات تحويلات المخازن...'}
              </p>
            </div>
          ) : data.length > 0 ? (
            <div className='table-responsive'>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>{i18n.language === 'en' ? 'Transfer Date' : 'تاريخ التحويل'}</th>
                    <th>{i18n.language === 'en' ? 'Transfer Code' : 'كود التحويل'}</th>
                    <th>{i18n.language === 'en' ? 'Item' : 'الصنف'}</th>
                    <th>{i18n.language === 'en' ? 'Item Code' : 'كود الصنف'}</th>
                    <th>{i18n.language === 'en' ? 'From Inventory' : 'من المخزن'}</th>
                    <th>{i18n.language === 'en' ? 'To Inventory' : 'إلى المخزن'}</th>
                    <th>{i18n.language === 'en' ? 'Quantity' : 'الكمية'}</th>
                    <th>{i18n.language === 'en' ? 'Unit Price' : 'سعر الوحدة'}</th>
                    <th>{i18n.language === 'en' ? 'Transfer Value' : 'قيمة التحويل'}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((transfer, index) => (
                    <tr key={`${transfer.transferCode}-${index}`}>
                      <td>{transfer.transferDate?.split('T')[0]}</td>
                      <td>
                        <Badge bg='primary'>{transfer.transferCode}</Badge>
                      </td>
                      <td>
                        <div>
                          {i18n.language === 'en' ? transfer.itemName : transfer.itemName2 || transfer.itemName}
                        </div>
                        {transfer.itemName2 && (
                          <div className='text-muted small'>
                            {i18n.language === 'en' ? transfer.itemName2 : transfer.itemName}
                          </div>
                        )}
                      </td>
                      <td>{transfer.itemCode}</td>
                      <td className='text-danger'>
                        {transfer.fromInventoryName ||
                          (i18n.language === 'en' ? 'Unknown Inventory' : 'مخزن غير معروف')}
                      </td>
                      <td className='text-success'>
                        {transfer.toInventoryName || (i18n.language === 'en' ? 'Unknown Inventory' : 'مخزن غير معروف')}
                      </td>
                      <td className='fw-bold'>{formatQuantity(transfer.quantity)}</td>
                      <td>{transfer.unitPrice}</td>
                      <td className='fw-bold text-info'>{transfer.quantity * transfer.unitPrice}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className='text-center py-5'>
              <p>
                {i18n.language === 'en'
                  ? 'No data available. Set your filters and click "Load Report" to generate.'
                  : 'لا توجد بيانات متاحة. قم بتعيين الفلاتر الخاصة بك وانقر على "تحميل التقرير" لإنشائه.'}
              </p>
            </div>
          )}
        </CardBody>

        {data.length > 0 && (
          <CardFooter className='text-muted'>
            <div className='row'>
              <div className='col-md-6'>
                <small>
                  <strong>{i18n.language === 'en' ? 'Transfer Summary:' : 'ملخص التحويلات:'}</strong>{' '}
                  {i18n.language === 'en'
                    ? `${totalTransfers} transfers involving ${uniqueItems} items across ${uniqueInventories} warehouses`
                    : `${totalTransfers} تحويلات تشمل ${uniqueItems} عنصر عبر ${uniqueInventories} مخزن`}
                </small>
              </div>
              <div className={`col-md-6 text-end `}>
                <small>
                  {i18n.language === 'en'
                    ? `Report generated on ${new Date().toLocaleString()}`
                    : `تم إنشاء التقرير في ${new Date().toLocaleString()}`}
                </small>
              </div>
            </div>
          </CardFooter>
        )}
      </Card>
    </div>
  );
};

export default WarehouseTransferReport;
